import {types} from './types';

const initialState = {
    list: {
        data: [],
        currentPage: 0,
        currentRowsPerpage: 0,
        total: 0,
        totalPage: 0
    }
}

export function postbackReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GET_POSTBACK_LOGS:
            return { ...state, list: action.payload};
        default:
            return state
    }
}